module.exports = __webpack_public_path__ + "static/media/telephone.a7ad9f65.svg";